import React from 'react'
import PropTypes from 'prop-types'

const CloseCircleIcon = ({ size = '40', background = '#C4C4C4', color = 'white' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="19.799"
        width="28"
        height="28"
        rx="14"
        transform="rotate(45 19.799 0)"
        fill={background}
      />
      <path
        d="M21.4382 19.799L24.1541 17.083L22.5149 15.4438L19.7989 18.1598L17.083 15.4438L15.4438 17.083L18.1597 19.799L15.4438 22.5149L17.083 24.1541L19.7989 21.4382L22.5149 24.1541L24.1541 22.5149L21.4382 19.799Z"
        fill={color}
      />
    </svg>
  )
}

export default React.memo(CloseCircleIcon)

CloseCircleIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  background: PropTypes.string,
}
